// Hostname-based site mode detection.
//
// The same React build is served on multiple custom domains via Cloudflare Pages:
//   - tracker.ksjewellerymumbai.com (prod) + dev.tracker.* (dev) — full app
//   - diamondhq.ksjewellerymumbai.com — stones-only view for suppliers/admin
//
// When users land on the stones-only host we hide the tracker nav, force
// /stones/* routing, and rebrand the header. This file is the single source
// of truth for that detection so we can change it in one place later (e.g.
// adding 'stones.example.com' as another alias).

const STONES_ONLY_HOST_PREFIXES = ['diamondhq.', 'diamond-hq.', 'stones.'];

export function isStonesOnlyHost() {
  if (typeof window === 'undefined') return false;
  const h = (window.location.hostname || '').toLowerCase();
  return STONES_ONLY_HOST_PREFIXES.some(p => h.startsWith(p));
}

export function siteModeLabel() {
  return isStonesOnlyHost() ? 'DiamondHQ' : 'PD Tracker';
}
